import { render, staticRenderFns } from "./BancosMovimientos.vue?vue&type=template&id=2ea14b9e&"
import script from "./BancosMovimientos.vue?vue&type=script&lang=js&"
export * from "./BancosMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports